// extracted by mini-css-extract-plugin
export default {"adjustButton":"yKuHwb","badge":"Ahl__M"};